// App tour — lead capture walkthrough for sales reps (5–8 steps, leads surfaces).

import type { FireflyTourArtifact } from "../tourTypes";

export const LEAD_CAPTURE_TOUR_ID = "tour-lead-capture";

export const LEAD_CAPTURE_TOUR: FireflyTourArtifact = {
  id: LEAD_CAPTURE_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "walk me through capturing a lead",
    "lead capture tour",
    "how do i capture a lead tour",
    "show me lead capture",
    "app tour capture",
  ],
  bucketRelevance: ["sales"],
  requiredRoles: ["sales"],
  steps: [
    {
      id: "nav-leads",
      target: { mode: "leads", anchorId: "mode-nav-leads", scrollIntoView: true },
      deferModeNavigation: true,
      skipWhenCurrentMode: "leads",
      copy: {
        title: "Open Leads",
        body: "Lead capture lives in Leads mode. Tap Leads in the sidebar rail or bottom bar to open the capture workspace.",
      },
      waitForClick: true,
    },
    {
      id: "activity-dock",
      target: { mode: "leads", anchorId: "activity-dock-tab", scrollIntoView: true },
      copy: {
        title: "Your Firefly tab",
        body: "Firefly follows you across Sales modes. Tap the tab anytime to expand Activity — unsent leads, checklists, and Ask Firefly live inside.",
      },
      advanceOn: "next_button",
    },
    {
      id: "new-customer",
      target: { mode: "leads", anchorId: "capture-lead", scrollIntoView: true },
      copy: {
        title: "Start capture",
        body: "Use New Customer when the toolbar shows it. If a lead is already open, Close Lead first, then start a fresh card — or keep capturing on the open lead with Listen.",
      },
      // Not waitForClick: New Customer unmounts while a lead is open; Next keeps the tour moving.
      advanceOn: "next_button",
    },
    {
      id: "voice-listen",
      target: { mode: "leads", anchorId: "capture-voice", scrollIntoView: true },
      copy: {
        title: "Voice capture",
        body: "With a lead open, Listen transcribes what you say and extracts name, phone, and notes for review.",
      },
      advanceOn: "next_button",
    },
    {
      id: "rerun-extraction",
      target: { mode: "leads", anchorId: "lead-rerun-extract", scrollIntoView: true },
      copy: {
        title: "Fix extracted fields",
        body: "If the transcript changes, re-run extraction before sending — you stay in control of what goes to CRM.",
      },
      advanceOn: "next_button",
    },
    {
      id: "send-lead",
      target: { mode: "leads", anchorId: "send-lead", scrollIntoView: true },
      copy: {
        title: "Send when ready",
        body: "Send to CRM only when name and phone validate. Firefly highlights the button — you tap to send.",
      },
      destructive: true,
    },
    {
      id: "recent-leads",
      target: { mode: "leads", anchorId: "recent-leads-section", scrollIntoView: true },
      copy: {
        title: "Recent leads",
        body: "Every capture lands in this list on the Leads screen. Open a row to review and send. When you have unsent drafts, expand Firefly — the Unsent leads section appears there with a Send all shortcut.",
      },
      advanceOn: "next_button",
    },
    {
      id: "ask-firefly",
      target: { mode: "leads", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask anytime",
        body: "Use Ask Firefly inside the expanded Firefly panel for quick how-to answers without leaving your flow.",
      },
      advanceOn: "next_button",
    },
  ],
};
